export default "/images/vendor/flag-icon-css/flags/4x3/er.svg?458bc299993e856c309df58a7fb0c4ea";